<template>
  <div class="bg-[#F3F3F3] border-t border-[#E5E5E5]">
    <div :class="{'grid place-content-center': !isCompanyPage, 'w-full': isCompanyPage}">
      <div :class="{'py-10': !isCompanyPage, 'py-4': isCompanyPage}">
        <!-- Layout regular (para páginas normais) -->
        <div v-if="!isCompanyPage" class="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-[30px] lg:gap-[60px] px-6">
          <div class="mt-6 lg:mt-10">
            <MainLogo :footer="true" />
          </div>

          <div class="mt-6 lg:mt-10">
            <div v-for="item of menu" :key="item.title">
              <h2 :class="{
                'text-left font-[\'Poppins\'] font-[500] mb-[10px]': true,
                'text-[22px]': item.type === 'big',
                'text-[16px]': item.type === 'small',
              }">
                <router-link :to="item.link" v-if="item.internal" class="text-[#343434] hover:text-[#2E6DD1]">{{
                  item.title }}</router-link>
                <a :href="item.link" target="_blank" v-else class="text-[#343434] hover:text-[#2E6DD1]">{{ item.title
                  }}</a>
              </h2>
            </div>
          </div>

          <div class="mt-6 lg:mt-10">
            <div>
              <a :href="this.clientPanel" target="_blank"
                class="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-[#3676DC] to-[#1956B7] text-white font-['Poppins'] font-semibold text-base uppercase rounded-lg gap-2 hover:shadow-lg transition-all duration-300"
              >
                JÁ SOU CLIENTE - ENTRAR
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="white"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        <!-- Layout simplificado (para páginas de empresas) -->
        <div v-else class="px-6 md:px-10 lg:px-16">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <div class="text-[#343434] text-[10px] font-['Poppins'] font-[500] mr-2">Uma solução:</div>
              <MainLogo :footer="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainLogo from "@/components/MainLogo.vue";

export default {
  components: {
    MainLogo,
  },
  data() {
    return {
      menu: [
        {
          title: "Fale com a BCompliance&Law",
          type: "small",
          link: process.env.VUE_APP_ENV === "hml" 
            ? "/empresas/6514520aa8580f000d921b36" 
            : "/empresas/60f0afde65125e0ebaeac18a",
          internal: true,
        },
        {
          title: "Políticas, termos e contratos",
          type: "small",
          link: "/politicas-termos-e-contratos",
          internal: true,
        }
      ],
    };
  },
  computed: {
    isCompanyPage() {
      // Verifica se a rota atual corresponde ao padrão /empresas/ID
      return /^\/empresas\/[a-zA-Z0-9]+/.test(this.$route.path);
    }
  },
};
</script>
